import { Controller } from "stimulus"
import { Turbo, cable } from "@hotwired/turbo-rails"

export default class extends Controller {
    reset() {
        this.element.reset()
    }
}